export const isDateAvailable = (deliveryDate, deliveryDates = []) => {
    return deliveryDates.filter(date => date.delivery_date.includes(deliveryDate)).length > 0
};